<mat-card class="height-100">
  <mat-card-header class="border-bottom">
    <mat-card-title>
      Adicionar Fornecedor
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <!-- CPF/CNPJ e INSC. EST. / RG -->
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-12">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>CPF/CNPJ </mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('cpf_cnpj')"
                mask="000.000.000-00||00.000.000/0000-00"
                (blur)="checkCpfCnpj()"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('repeated')
              "
            >
              {{ messages.cpf_cnpj.repeated }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('required')
              "
            >
              {{ messages.cpf_cnpj.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('pattern')
              "
            >
              {{ messages.cpf_cnpj.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('duplicate')
              "
            >
              {{ messages.cpf_cnpj.duplicate }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('maxlength')
              "
            >
              {{ messages.cpf_cnpj.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCPF')
              "
            >
              {{ messages.cpf_cnpj.validateCPF }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCNPJ')
              "
            >
              {{ messages.cpf_cnpj.validateCNPJ }}
            </small>
          </div>
        </div>
        <!-- NOME -->
        <div class="flex-column mt-2 col-md-12">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Nome/razão social </mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('nome_razao_social')"
            />
          </mat-form-field>

          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('required')
            "
          >
            {{ messages.nome_razao_social.required }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('maxlength')
            "
          >
            {{ messages.nome_razao_social.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('minlength')
            "
          >
            {{ messages.nome_razao_social.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('isEmptyValue')
            "
          >
            {{ messages.nome_razao_social.isEmptyValue }}
          </small>
        </div>
        <!-- APELIDO -->
        <div class="flex-column mt-2 col-md-12">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Apelido/nome fantasia</mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('apelido_nome_fantasia')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('maxlength')
            "
          >
            {{ messages.apelido_nome_fantasia.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('minlength')
            "
          >
            {{ messages.apelido_nome_fantasia.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('isEmptyValue')
            "
          >
            {{ messages.apelido_nome_fantasia.isEmptyValue }}
          </small>
        </div>

        <!-- INSC. EST. / RG - INSC. MUNC. -->
        <div class="flex width-100">
          <div
            [class]="
              usaFiscal
                ? 'flex-column mt-2 col-md-4'
                : 'flex-column mt-2 col-md-6'
            "
          >
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Inscrição estadual</mat-label>
              <input
                matInput
                (keydown)="notText($event)"
                (blur)="checkRgInscEstadual()"
                type="text"
                [formControl]="form.get('rg_insc_est')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('pattern')"
            >
              {{ messages.rg_insc_est.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('maxlength')"
            >
              {{ messages.rg_insc_est.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
            >
              {{ messages.rg_insc_est.existSpecialChar }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
            >
              {{ messages.rg_insc_est.isEmptyValue }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('duplicate')"
            >
              {{ messages.rg_insc_est.duplicate }}
            </small>
          </div>
          <div class="mt-2 col-md-4" *ngIf="usaFiscal">
            <mat-form-field
              style="width: 100% !important;"
              appearance="outline"
            >
              <mat-label>Regime tributário</mat-label>
              <mat-select [formControl]="form.controls.crt">
                <mat-option *ngFor="let i of crtOptions" [value]="i.value">{{
                  i.viewValue
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('crt').touched && form.get('crt').hasError('required')
              "
            >
              Regime tributário é obrigatório
            </small>
          </div>

          <div [class]="usaFiscal ? 'mt-2 col-md-4' : 'mt-2 col-md-6'">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Desconto</mat-label>
              <input
                class="text-right"
                [formControl]="form.get('desconto')"
                type="text"
                matInput
                (keydown)="validateOnlyNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('existSpecialChar')
              "
            >
              {{ messages.desconto.existSpecialChar }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('required')
              "
            >
              {{ messages.desconto.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('invalidNumber')
              "
            >
              {{ messages.desconto.invalidNumber }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('min')
              "
            >
              {{ messages.desconto.min }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('menor_valor')
              "
            >
              {{ messages.desconto.menor_valor }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('notNumbers')
              "
            >
              {{ messages.desconto.notNumbers }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('before_split')
              "
            >
              {{ messages.desconto.before_split }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('after_split')
              "
            >
              {{ messages.desconto.after_split }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('errorComma')
              "
            >
              {{ messages.desconto.errorComma }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('errorDots')
              "
            >
              {{ messages.desconto.errorDots }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('desconto').touched &&
                form.get('desconto').hasError('max_value')
              "
            >
              {{ messages.desconto.max_value }}
            </small>
          </div>
        </div>

        <mat-slide-toggle
          color="primary"
          [formControl]="form.get('validar_limite_credito')"
          ngDefaultControl
          class="mt-2 col-md-12 mb-3 mt-3"
          id="field-a-prazo"
        >
          Validar limite de crédito
        </mat-slide-toggle>
      </mat-tab>
      <mat-tab label="Endereços" style="flex: 1;">
        <ng-template mat-tab-label>
          Endereço
          <i
            *ngIf="formAddressValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
      </mat-tab>
      <mat-tab label="Contatos">
        <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <div class="row m-0 pb-2">
      <div class="width-100" style="display: flex; justify-content: flex-end;">
        <button mat-stroked-button color="warn" [matDialogClose]="undefined">
          Cancelar
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!formValid"
        >
          Cadastrar
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
